import { FC } from 'react';
import BottomNavigationItems from '../bottomNavigationItems/BottomNavigationItems';
import type { MobileBottomNavigationPropsTypes } from './types/propsTypes';
import styles from './MobileBottomNavigation.module.scss';

const MobileBottomNavigation: FC<MobileBottomNavigationPropsTypes> = ({
  navigationItems,
  activeRoute,
  hasStickyBottomBar,
}) => (
  <nav
    className={` ${styles['mobile-footer-container']}  ${hasStickyBottomBar ? styles['sticky-bottom-bar-border'] : ''}`}
    data-testid="mobile-nav-test-id"
  >
    <ul className={styles['mobile-footer-item-list']}>
      {navigationItems.map((item) => (
        <BottomNavigationItems key={item.url} activeRoute={activeRoute} {...item} />
      ))}
    </ul>
  </nav>
);
export default MobileBottomNavigation;
